import { render, staticRenderFns } from "./ApiOrcidActiveSearch.vue?vue&type=template&id=08b204b6&scoped=true"
import script from "./ApiOrcidActiveSearch.vue?vue&type=script&lang=js"
export * from "./ApiOrcidActiveSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b204b6",
  null
  
)

export default component.exports